export enum DimensionCategory {
  IncomingInvoice,
  Receipt,
  Invoice,
  CashReconciliation,
  All,
  MissingDocumentOther,
}
